import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.102 14.934H9.937L8.81 9.042h6.302l-1.01 5.892zM2.65 3a.64.64 0 00-.64.743l2.72 16.513a.87.87 0 00.851.727h13.05a.64.64 0 00.64-.538l2.72-16.698a.64.64 0 00-.64-.744L2.648 3z"
    />
  </svg>
);
